import React, { CSSProperties } from 'react';
import './Cube.scss';
import { IOneIcon } from '../../global';
import { renderImg } from '../../utils/dom';

interface ICube extends IOneIcon {
  text?: string;
  style?: CSSProperties;
  onClick?: (e: any) => void;
  event?: string;
}

function Cube(props: ICube) {
  return (
    <div
      className="cube"
      style={props.style}
      onClick={props.onClick}
      data-stat={props.event}
    >
      {renderImg(props)}
      <span className={'text'}>{props.text}</span>
    </div>
  );
}

export default Cube;
